import SliderCreator from '../atoms/SliderCreator'

const carouselManager = () => {
  document.addEventListener('DOMContentLoaded', e => {
    mainTnsCarousel()
    oneItemCarousel()
    threeItemsCarousel()
    clientsCarousel()
  })
}


const mainTnsCarousel = () => {
  SliderCreator('.main-tnsCaroousel')
}

const oneItemCarousel = () => {
  SliderCreator('.one-item-tns')
}

const threeItemsCarousel = () => {
  const config = {
    responsive: {
      '320': {
        'items': 1
      },
      '768': {
        'items': 3
      }
    },
    slideBy: 1
  }
  SliderCreator('.three-items-tns', config)
}

const clientsCarousel = () => {
  const config = {
    responsive: {
      '320': {
        'items': 1
      },
      '768': {
        'items': 3
      },
      '1024': {
        'items': 4
      },
      '1216': {
        'items': 5
      }
    },
    slideBy: 1
  }
  SliderCreator('.clients-items-tns', config)
}

export default carouselManager
